<template>
  <section class="rev-ras-post-carrousel-module-component">
    <div class="rr-container">
      <div class="title-container">
        <div class="divider-container">
          <BicolorLine
            extraclass="w-full"
            :bigger="true"
            left="approachable"
            right="progressive" />
        </div>
        <h2
          v-if="data.section_title"
          v-html="data.section_title"></h2>
      </div>
    </div>
    <div class="rr-container carousel">
      <div
        v-if="device !== 'desktop' || displayedArticles.length <= 2"
        class="cards-container">
        <a
          v-for="(carousel, idx) of mobileArticles"
          :key="`cards-${idx}`"
          :href="carousel?.permalink || '#'"
          :alt="carousel?.post_title"
          :target="carousel?.permalink ? '_self' : '_blank'"
          class="carousel-card">
          <div class="card-image">
            <img
              :src="carousel?.acf?.carrousel_image.url"
              class="card-image-tag" />
          </div>
          <div class="card-text">
            <div class="title-info">
              <p
                v-if="articleCategoryName(carousel)"
                class="article-category"
                v-html="articleCategoryName(carousel)"></p>

              <p
                v-if="carousel?.post_title"
                class="article-name"
                v-html="carousel?.post_title"></p>

              <div
                class="description"
                v-html="carousel?.acf?.description"></div>
            </div>

            <a
              :href="carousel?.permalink || '#'"
              class="carousel-link"
              ><svg
                xmlns="http://www.w3.org/2000/svg"
                width="53"
                height="58"
                viewBox="0 0 53 58"
                fill="none">
                <path
                  d="M22.9732 0.914679C25.1184 -0.304941 27.7473 -0.304939 29.8925 0.914681L49.3253 11.9628C51.5138 13.2071 52.8656 15.5306 52.8656 18.0481V39.9588C52.8656 42.4763 51.5138 44.7999 49.3253 46.0441L29.8925 57.0923C27.7473 58.3119 25.1184 58.3119 22.9732 57.0923L3.54033 46.0441C1.35182 44.7999 0 42.4763 0 39.9588V18.0481C0 15.5306 1.35183 13.2071 3.54033 11.9628L22.9732 0.914679Z"
                  fill="#13D377" />
                <path
                  d="M33.4544 36.3491L33.0878 35.9825L33.0783 29.8648C33.0729 26.4138 33.3589 25.3946 33.3321 25.0024C33.3317 24.7409 33.2532 24.6624 33.1223 24.5837C32.9915 24.5051 32.8347 24.5572 32.6781 24.7138C32.3648 25.027 31.5822 26.1238 29.3895 28.3165L19.2875 38.4185L18.7646 38.4177L17.691 37.3441L17.6902 36.8213L27.8183 26.6931C30.011 24.5005 31.1079 23.7178 31.4211 23.4046C31.5777 23.248 31.6298 23.0912 31.5511 22.9604C31.4725 22.8295 31.3939 22.751 31.1325 22.7506C30.7665 22.75 29.7211 23.0098 26.2701 23.0044L20.1523 22.9949L19.7858 22.6283L19.7836 21.2165L20.149 20.851L34.7375 20.8738L35.2088 21.3451L35.2577 35.9598L34.8923 36.3252L33.4805 36.323L33.4544 36.3491Z"
                  fill="#0E4343" /></svg
            ></a>
          </div>
        </a>
      </div>

      <div
        v-if="device === 'desktop' && displayedArticles.length > 2"
        class="carousel-container">
        <Splide
          :options="trackOptions"
          :has-track="false"
          aria-label="Posts">
          <div class="splide__arrows">
            <button
              class="splide__arrow splide__arrow--prev rotate-180"
              type="button">
              <div class="navigation-icon">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="25"
                  height="24"
                  viewBox="0 0 25 24"
                  fill="none">
                  <path
                    d="M24.9023 12L12.9023 24L11.2256 22.3232L20.3633 13.1855L-1.15272e-06 13.1855L-9.45344e-07 10.8135L20.3623 10.8135L11.2256 1.67676L12.9023 1.12796e-06L24.9023 12Z"
                    fill="#00206A" />
                </svg>
              </div>
            </button>
            <button
              class="splide__arrow splide__arrow--next"
              type="button">
              <div class="navigation-icon">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="25"
                  height="24"
                  viewBox="0 0 25 24"
                  fill="none">
                  <path
                    d="M24.9023 12L12.9023 24L11.2256 22.3232L20.3633 13.1855L-1.15272e-06 13.1855L-9.45344e-07 10.8135L20.3623 10.8135L11.2256 1.67676L12.9023 1.12796e-06L24.9023 12Z"
                    fill="#00206A" />
                </svg>
              </div>
            </button>
          </div>
          <SplideTrack>
            <SplideSlide
              v-for="(carousel, idx) of displayedArticles"
              :key="`carousel-item-${idx}`">
              <a
                class="carousel-card"
                :href="carousel?.permalink || '#'"
                :alt="carousel?.post_title"
                :target="carousel?.permalink ? '_self' : '_blank'">
                <div class="card-image">
                  <img
                    :src="carousel?.acf?.carrousel_image.url"
                    class="card-image-tag" />
                </div>
                <div class="card-text">
                  <div class="title-info">
                    <p
                      v-if="articleCategoryName(carousel)"
                      class="article-category"
                      v-html="articleCategoryName(carousel)"></p>

                    <p
                      v-if="carousel?.post_title"
                      class="article-name"
                      v-html="carousel?.post_title"></p>

                    <div
                      class="description"
                      v-html="carousel?.acf?.description"></div>
                  </div>

                  <a
                    :href="carousel?.permalink || '#'"
                    class="carousel-link"
                    ><svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="53"
                      height="58"
                      viewBox="0 0 53 58"
                      fill="none">
                      <path
                        d="M22.9732 0.914679C25.1184 -0.304941 27.7473 -0.304939 29.8925 0.914681L49.3253 11.9628C51.5138 13.2071 52.8656 15.5306 52.8656 18.0481V39.9588C52.8656 42.4763 51.5138 44.7999 49.3253 46.0441L29.8925 57.0923C27.7473 58.3119 25.1184 58.3119 22.9732 57.0923L3.54033 46.0441C1.35182 44.7999 0 42.4763 0 39.9588V18.0481C0 15.5306 1.35183 13.2071 3.54033 11.9628L22.9732 0.914679Z"
                        fill="#13D377" />
                      <path
                        d="M33.4544 36.3491L33.0878 35.9825L33.0783 29.8648C33.0729 26.4138 33.3589 25.3946 33.3321 25.0024C33.3317 24.7409 33.2532 24.6624 33.1223 24.5837C32.9915 24.5051 32.8347 24.5572 32.6781 24.7138C32.3648 25.027 31.5822 26.1238 29.3895 28.3165L19.2875 38.4185L18.7646 38.4177L17.691 37.3441L17.6902 36.8213L27.8183 26.6931C30.011 24.5005 31.1079 23.7178 31.4211 23.4046C31.5777 23.248 31.6298 23.0912 31.5511 22.9604C31.4725 22.8295 31.3939 22.751 31.1325 22.7506C30.7665 22.75 29.7211 23.0098 26.2701 23.0044L20.1523 22.9949L19.7858 22.6283L19.7836 21.2165L20.149 20.851L34.7375 20.8738L35.2088 21.3451L35.2577 35.9598L34.8923 36.3252L33.4805 36.323L33.4544 36.3491Z"
                        fill="#0E4343" /></svg
                  ></a>
                </div>
              </a>
            </SplideSlide>
          </SplideTrack>
        </Splide>
      </div>

      <div
        v-if="data.add_button"
        class="button-container">
        <ButtonGlobal
          :text="data.button.title"
          :url="data.button.url"
          :target="data.button.target" />
      </div>
    </div>
  </section>
</template>

<script setup>
/* #META
 {
  "NAME": "RevRasPostCarrouselComponent",
  "CLASSNAME": "rev-ras-post-carrousel-module-component",
  "URL": "http://vuevitewp.local/test"
 }
#ENDMETA */

/*
 * Insert your logic here
 */
import { Splide, SplideSlide, SplideTrack } from '@splidejs/vue-splide'
import { computed, ref, watch } from 'vue'
import { useStore } from '@/stores/main'
import BicolorLine from '@/components/utility/BicolorLine.vue'
import ButtonGlobal from '@/components/utility/ButtonGlobal.vue'
import useUtils from '@/components/composables/useUtils'
import '@splidejs/vue-splide/css/core'

const props = defineProps(['data'])

const { device } = useUtils()
const store = useStore()
const newestArticles = ref([])
let newestArticlesRequestId = 0

const pullNewestArticles = computed(() =>
  [true, 1, '1'].includes(props.data?.pull_newest_posts)
)

const maximumNumberOfPosts = computed(() => {
  const maximum = Number.parseInt(props.data?.maximum_number_of_posts, 10)

  return Number.isFinite(maximum) ? maximum : 0
})

const normalizeArticle = (article) => ({
  ...article,
  post_title: article?.post_title || article?.title?.rendered || '',
  permalink: article?.permalink || article?.link || '',
})

const selectedArticles = computed(() =>
  Array.isArray(props.data?.articles)
    ? props.data.articles.map(normalizeArticle)
    : []
)

const displayedArticles = computed(() =>
  pullNewestArticles.value ? newestArticles.value : selectedArticles.value
)

const mobileArticles = computed(() => displayedArticles.value.slice(0, 3))

const loadNewestArticles = async () => {
  const activeRequest = ++newestArticlesRequestId

  if (!pullNewestArticles.value) {
    newestArticles.value = []
    return
  }

  try {
    const maximum = maximumNumberOfPosts.value
    const perPage = maximum > 0 ? Math.min(maximum, 100) : 100
    const articles = []
    let page = 1
    let totalPages = 1

    do {
      const request = {
        type: 'articles',
        params: {
          per_page: perPage,
          page,
          orderby: 'date',
          order: 'desc',
        },
        showLoading: false,
      }

      await store.getItems(request)

      if (activeRequest !== newestArticlesRequestId) return

      articles.push(...store.requestedItems(request).map(normalizeArticle))

      const storedRequest = store.request(request)
      totalPages = Number.parseInt(storedRequest?.totalPages, 10) || 1
      page += 1
    } while (page <= totalPages && (maximum <= 0 || articles.length < maximum))

    if (activeRequest !== newestArticlesRequestId) return

    newestArticles.value = maximum > 0 ? articles.slice(0, maximum) : articles
  } catch (error) {
    if (activeRequest !== newestArticlesRequestId) return

    newestArticles.value = []
    console.error('Unable to load the newest articles.', error)
  }
}

watch([pullNewestArticles, maximumNumberOfPosts], loadNewestArticles, {
  immediate: true,
})

const articleCategoryName = (article) => {
  const category = article?.acf?.article_categories?.[0]

  if (category && typeof category === 'object') {
    return category.name || ''
  }

  return typeof category === 'string' && !/^\d+$/.test(category) ? category : ''
}

const trackOptions = {
  rewind: false,
  perPage: 3,
  perMove: 1,
  focus: 0,
  trimSpace: true,
  speed: 500,
  interval: 5000,
  pagination: true,
  arrows: true,
  padding: { right: '0' },
  type: 'slide',
  autoplay: false,
  gap: '32px',
}
</script>

<style lang="scss" scoped>
.rev-ras-post-carrousel-module-component {
  @apply bg-balanced py-10 lg:pb-20 lg:pt-2;

  .rr-container {
    @apply lg:pr-0;
  }

  .title-container {
    @apply flex flex-col gap-7 lg:gap-10 lg:px-8;

    .divider-container {
      .bicolor-line {
        @apply w-full;
      }
    }
    h2 {
      @apply header-2 text-white;
    }
  }

  .cards-container {
    @apply pt-8 pb-[50px] flex flex-col gap-6 lg:flex-row lg:gap-14;
  }

  .carousel-card {
    @apply relative max-w-[500px] flex bg-white overflow-hidden rounded-[27px] flex-col gap-6 w-full items-center;
    @apply lg:max-w-[440px];

    .full-button {
      @apply absolute top-0 left-0 w-full h-full z-[100] cursor-pointer;
    }

    &:before {
      @apply pointer-events-none absolute top-0 left-0 w-full h-full z-2 opacity-0 bg-balanced transition-opacity duration-300 ease-out;
      content: '';
    }

    .card-image {
      @apply relative w-full h-[203px] object-cover object-center rounded-[27px] overflow-hidden;
      @apply lg:h-[256px];

      img {
        @apply w-full h-full object-cover;
      }
    }

    .card-text {
      @apply px-8 pb-4 flex flex-col lg:flex-1 lg:h-auto lg:justify-between lg:px-10 lg:gap-5 lg:pb-6;

      .title-info {
        @apply mt-0;

        .description {
          :deep(*) {
            @apply text-[16px] leading-[1.2] mb-5 lg:text-[18px];
          }
        }

        .article-name {
          @apply header-5 normal-case text-balanced mb-9;
        }

        .article-category {
          @apply text-[13px] text-balanced mb-3;
        }
      }

      .carousel-link {
        @apply self-end lg:translate-x-2;
      }
    }
  }

  .carousel-container {
    @apply relative flex w-full h-full pt-9 lg:pb-12;
    @apply lg:pt-10;

    .carousel-card {
      @apply w-full max-w-none pointer-events-none;

      &:before {
        @apply opacity-40;
      }
    }

    .navigation-icon {
      @apply w-10 h-10 rounded-full bg-white flex items-center justify-center;

      svg {
        @apply w-5 h-5;

        path {
          @apply fill-progressive;
        }
      }
    }

    .splide {
      @apply w-full;
      position: initial;

      .splide__track {
        @apply z-1;
        .splide__list {
          @apply gap-14;
          background: red;

          .splide__slide {
            @apply flex min-w-0;

            .carousel-card {
              @apply flex-1;
            }
          }
        }
      }
      .splide__arrows {
        @apply flex justify-end items-center absolute bottom-0 gap-5 right-0 left-0 w-full z-2;
        @apply lg:bottom-[-50px] lg:left-auto lg:w-auto;

        .splide__arrow {
          @apply transition-opacity duration-300 ease-out;

          &[disabled] {
            @apply pointer-events-none cursor-default opacity-40;
          }
        }
      }
      .splide__pagination {
        @apply flex justify-center items-center z-2 gap-x-6 mt-12;
        .splide__pagination__page {
          @apply w-3 h-3 rounded-full bg-gray-500 cursor-pointer opacity-40;
          &.is-active {
            @apply opacity-100;
          }
        }
      }

      .splide__slide.is-active {
        .carousel-card {
          @apply pointer-events-auto;

          .card-image {
            p {
              @apply opacity-50;
            }
          }

          &:before {
            @apply opacity-0;
          }
        }
      }
    }
  }

  .button-container {
    @apply lg:pr-20;
  }
}
</style>
